import { Trans, useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import Button from "src/Components/Button/Button"

const UserWithAdminRole = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className='pt-3'>
                <Trans i18nKey='AdminAndMemberRegistrationSuccessInstruction' />
            </div>
            <div className='pt-5'>
                <Link to="/licences">
                    <Button
                        text={t('OrderLicences')}
                        backgroundColor='var(--primary-gradient)'
                        borderColor="var(--primary-color)"
                        color="white"
                        onClick={() => { }}
                    />
                </Link>
            </div>
            <div className='pt-3'>
                <Link to="/app">
                    <Button
                        text={t('DownloadAuraApp')}
                        backgroundColor='none'
                        borderColor="none"
                        color="var(--primary-color)"
                        onClick={() => { }}
                    />
                </Link>
            </div>
        </>
    )
}
export default UserWithAdminRole